import { imgV2 as img } from '@styles/utils';
import parse from 'html-react-parser';

import { IProduct } from '@interfaces';
import { categoryMapSingle } from '@components/common/products/utils';
import Clickable from '@v2/components/common/presentational/clickables/default';

import styles from '@components/common/products/product.styles';
import { scrollIntoView } from '@v2/utils/scroll';

export default function CollaborationDescription({ product }: { product?: IProduct }) {
    const collaborationProducts: IProduct[]  = (product.collaboration && product.collaboration.collaborationProducts) ? product.collaboration.collaborationProducts : [];
    const cerebellyProducts: IProduct[]  = (product.collaboration && product.collaboration.cerebellyProducts) ? product.collaboration.cerebellyProducts : [];

    return (
        <div className={styles.description}>
            <div className="right">
                <div className="right-wrapp animate__animated animate__fadeInUp-home">
                    <div className="pdp-header">
                        <h3>{categoryMapSingle(product.category)}</h3>
                    </div>
                    <h2>{product.title}</h2>
                    <div className="pdp-desc">
                        {parse(product.description)}
                    </div>
                    <div className="pdp-header">
                        <h3>What’s Inside</h3>
                    </div>
                    <div className="pdp-desc">
                        {Object.values(cerebellyProducts)
                            .map((line: any, key: number) => <div key={key}>{line.quantity} x {line.title}</div>)}
                        {Object.values(collaborationProducts)
                            .map((line: any, key: number) => <div key={key}>{line.quantity} x The Dough Project {line.title}</div>)}
                    </div>
                    <div className="explanation-video">
                        <Clickable onClick={() => scrollIntoView('safety')}>
                            <div className="directions-safety">
                                <img className="info-icon" src={img('pdp2/info-icon.svg')} alt="" />
                                <span className="heading">directions & safety</span>
                            </div>
                        </Clickable>
                    </div>
                </div>
            </div>
        </div>
    );
}